import { createRouter, createWebHistory } from "vue-router";

import HomePage from "../pages/HomePage.vue"; // Adjust the relative path as needed
import SponsorshipPage from "../pages/SponsorshipPage.vue";
import ContactUs from "../pages/ContactUs.vue";
import UpcomingEvents from "../components/UpcomingEvents.vue";
import Raffle from "../pages/RafflePage.vue";
import RecordsPage from "../pages/RecordsPage.vue"
import ProposalPdfPage from "@/pages/ProposalPdfPage.vue"
import AboutPage from "../pages/AboutPage.vue"
import BigCatContest from "../components/BigCatContest.vue"
import WildlifeModel from "@/pages/wildlife-model.vue";
import DonatePage from "@/pages/DonatePage.vue";
import DesignSystemPage from "../pages/DesignSystemPage.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/sponsorship",
    name: "Sponsorship",
    component: SponsorshipPage,
  },
  {
    path: "/sponsor",
    name: "Sponsorship",
    component: SponsorshipPage,
  },
  {
    path: "/events",
    name: "Events",
    component: UpcomingEvents,
  },
  {
    path: "/contact",
    name: "ContactUs",
    component: ContactUs,
  },
  {
    path: "/donate",
    name: "Donate",
    component: DonatePage,
  },
  {
    path: "/Raffle",
    alias: "/raffle",
    name: "Raffle",
    component: Raffle,
  },
  {
    path: "/Records",
    name: "Records",
    component: RecordsPage,
  },
    {
    path: "/proposal-pdf",
    name: "ProposalPDF",
    component: ProposalPdfPage,
  },
  {
    path: "/About",
    name: "About",
    component: AboutPage,
  },
  {
    path: "/BigCatContest",
    name: "BigCatContest",
    component: BigCatContest,
  },
    {
    path: "/wildlife-model",
    name: "WildlifeModel",
    component: WildlifeModel,
  },
  {
    path: "/design-system",
    name: "DesignSystem",
    component: DesignSystemPage,
  },
];

const router = createRouter({
  history: createWebHistory(), // Use history mode for clean URLs
  routes,
});

export default router;
